import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { Check, PawPrint } from "lucide-react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import api from "../lib/api";

const PaymentSuccess = () => {
  const [searchParams] = useSearchParams();
  const sessionId = searchParams.get("session_id");
  const [status, setStatus] = useState("checking");

  useEffect(() => {
    let tries = 0;
    let interval;
    const poll = async () => {
      if (!sessionId) {
        setStatus("unknown");
        return;
      }
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") {
          setStatus("paid");
          clearInterval(interval);
          toast.success("Payment received — thank you!");
        } else if (tries > 10) {
          setStatus("pending");
          clearInterval(interval);
        }
      } catch {
        if (tries > 10) setStatus("pending");
      }
      tries += 1;
    };
    poll();
    interval = setInterval(poll, 2000);
    return () => clearInterval(interval);
  }, [sessionId]);

  return (
    <div className="min-h-screen bg-cream">
      <Navbar />
      <div className="flex min-h-[75vh] flex-col items-center justify-center px-6 py-24 text-center">
        {status === "paid" ? (
          <>
            <span className="flex h-20 w-20 items-center justify-center rounded-full bg-forest/10">
              <Check className="h-9 w-9 text-forest" />
            </span>
            <h1 className="mt-8 font-display text-5xl font-medium tracking-tight text-ink md:text-6xl">
              Payment <em className="text-marmalade">received.</em>
            </h1>
            <p className="mt-5 max-w-md text-base leading-relaxed text-inkSoft">
              Thank you — your booking is all set. Ari will see you (and your pet) soon.
            </p>
          </>
        ) : (
          <>
            <span className="flex h-20 w-20 items-center justify-center rounded-full bg-sand">
              <PawPrint className="h-9 w-9 text-marmalade" />
            </span>
            <h1 className="mt-8 font-display text-5xl font-medium tracking-tight text-ink md:text-6xl">
              {status === "checking" ? "Confirming…" : "Almost there."}
            </h1>
            <p className="mt-5 max-w-md text-base leading-relaxed text-inkSoft">
              {status === "checking"
                ? "Confirming your payment with the bank — this usually takes a few seconds."
                : "Your payment is still confirming. Check back here in a moment — your booking reference always shows the latest status."}
            </p>
          </>
        )}
        <div className="mt-10 flex flex-wrap justify-center gap-4">
          <Link
            to="/"
            data-testid="payment-success-home"
            className="rounded-full bg-forest px-7 py-3.5 font-mono text-[11px] uppercase tracking-[0.2em] text-cream transition-colors duration-300 hover:bg-ink"
          >
            Back home
          </Link>
          {sessionId && (
            <Link
              to="/pay"
              data-testid="payment-success-pay"
              className="rounded-full border border-ink/15 px-7 py-3.5 font-mono text-[11px] uppercase tracking-[0.2em] text-ink transition-colors duration-200 hover:bg-sand"
            >
              Booking status
            </Link>
          )}
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default PaymentSuccess;
